import { combineReducers } from 'redux';

import {
  CHECKIN,
  NEXT,
  NEW_CHECKIN,
  NEW_NEXT,
  MANUAL_PAYMENT,
  CHECK_PAYMENT,
  IDASTART,
  IDANEXT,
  RANDOM_NEXT,
  NEW_RANDOM_NEXT,
  LAST_NEXT,
  NEW_LAST_NEXT,
  SET_TEST_SUBJECT,
  RESUME_APPLICATION,
} from '../actions/navigation';

const checkinData = (state = {}, action) => {
  switch (action.type) {
    case CHECKIN:
    case NEXT:
    case MANUAL_PAYMENT:
    case CHECK_PAYMENT:
    case IDASTART:
    case IDANEXT:
    case NEW_CHECKIN:
    case NEW_NEXT:
    case RANDOM_NEXT:
    case LAST_NEXT:
    case NEW_RANDOM_NEXT:
    case NEW_LAST_NEXT:
    case RESUME_APPLICATION:
      return action.status === 'done' ? { ...action.data.data } : state;
    default:
      return state;
  }
};

const testSubjectData = (state = {}, action) => {
  switch (action.type) {
    case SET_TEST_SUBJECT:
      return action.payload ? { ...action.payload } : state;
    default:
      return state;
  }
};

export const screen = combineReducers({
  checkinData,
  testSubjectData,
});
